<template>
  <admin-page-shell
    :title="$t('frontend_builder_dropdown_settings')"
    :subtitle="$t('frontend_groovemail_admin_configure_settings')"
  >
    <template slot="tabs">
      <gd-tabs
        :tabs="tabs"
        :currentTab="currentTab"
        :disableNotCompleted="false"
        @onClick="handleTabChange"
      />
    </template>
    <component :is="currentTab"/>
  </admin-page-shell>
</template>

<script>
import BounceBlockSetting from './bounce-block-setting.vue';
import UnsubscribeDataSetting from './unsubscribe-data-setting.vue';
import BccEmailSetting from './bcc-email-setting.vue';
import CustomMessageSetting from './custom-message-setting.vue';
import VerificationSetting from './verification-setting.vue';
import TransactionMailSetting from './transaction-mail-setting.vue';
import UnsubscriptionSetting from './unsubscription-setting.vue';
import AdminPageShell from '../AdminPageShell.vue';

export default {
  middleware: 'auth',

  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_settings_title') };
  },

  data() {
    return {
      currentTab: 'bounceSetting',
    };
  },

	components: {
    AdminPageShell,
    bounceSetting: BounceBlockSetting,
    unsubscribeSetting: UnsubscribeDataSetting,
    copyEmail: BccEmailSetting,
    messageSetting: CustomMessageSetting,
    transactionMailSetting: TransactionMailSetting,
    verificationSetting: VerificationSetting,
    unsubscriptionSetting: UnsubscriptionSetting,
  },

  methods: {
	  /**
     * Used to handle tab change based on admin settings type.
     * @param {string} newTab changed tab.
     */
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
  },

  computed: {
	  /**
     * Returns admin settings tabs data.
     * @return {array} - array of admin settings tabs
     */
    tabs() {
      return [
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_bounce_block_settings'
          )}<span>`,
          value: 'bounceSetting',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_unsubscribe_data_settings'
          )}<span>`,
          value: 'unsubscribeSetting',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_bcc_email_settings'
          )}<span>`,
          value: 'copyEmail',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_settings_message_settings'
          )}<span>`,
          value: 'messageSetting',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_settings_verification_settings'
          )}<span>`,
          value: 'verificationSetting',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_settings_transactional_mail_settings'
          )}<span>`,
          value: 'transactionMailSetting',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_settings_unsubscription_settings'
          )}<span>`,
          value: 'unsubscriptionSetting',
        },
      ];
    },

	  /**
     * Returns class for admin settings tab.
     * @return {string} - class for admin settings tab.
     */
    mainTabClass() {
      return 'pb-2 gs-default-tabs-item';
    },
  },
};
</script>